// 对象基础字段
import {
  conditionEnum,
  fieldTypeConfig,
  fieldTypeEnum,
  moduleType,
  operateListEnum
} from '@/enums/preObjectManage'
import type {
  ComponentType,
  dragFieldData,
  FieldType,
  libraryListType,
  SubType
} from '@/types/preObjectManage'
import allFieldDataClass from './index'
import { _randomInt, GenNonDuplicateID, getUuid } from '@/utils/tools'
import type { List } from '@/types/common'
import { customCompNameEnums } from '@/components/custom/form/components/registerFormComponent'
import {
  isArray,
  isEmpty,
  isNullOrUnDef,
  isNullOrUndefOrEmpty,
  isString,
  isJSON,
  isNumber
} from '@/utils/is'
import { emailReg, idCardReg, phoneIsDesensitization } from '@/utils/regExp'
import { Mapping, Quote, QuoteMapping } from '@/utils/render/quoteMapping'
import { getCascadeLabel } from '@/utils/util'
import globalEnv from '@/configs'
export const quickList = [
  {
    label: '昨天',
    value: '1'
  },
  {
    label: '今天',
    value: '2'
  },
  {
    label: '最近1天',
    value: '3'
  },
  {
    label: '最近3天',
    value: '4'
  },
  {
    label: '最近1周',
    value: '5'
  },
  {
    label: '最近2周',
    value: '6'
  },
  {
    label: '最近1月',
    value: '7'
  }
]
/**
 * @author：张胜1
 * @desc：列表的默认列表
 * */
export const defaultList = [
  { value: '选项1', label: '选项1' },
  { value: '选项2', label: '选项2' },
  { value: '选项3', label: '选项3' }
]
/**
 * @author：张胜
 * @desc：获取对象字段信息
 * */
export function getFieldBaseDataFn(data: ComponentType): ComponentType {
  return {
    id: data.id || 0,
    tableCode: data.tableCode || 0,
    positionId: data.positionId || 0,
    containerId: data.containerId || 0,
    moduleId: data.moduleId || 0,
    columnId: data.columnId || 0,
    columnSerial: data.columnSerial || '',
    layout: data.layout || '',
    tId: data.tId || '',
    columnInfo: {
      id: data.columnInfo?.id || 0,
      tableCode: data.columnInfo?.tableCode || '',
      tableField: data.columnInfo?.tableField || '',
      tableAlias: data.columnInfo?.tableAlias || '',
      tableName: data.columnInfo?.tableName || '',
      code: data.columnInfo?.code || '',
      defineType: data.columnInfo?.defineType || 0,
      name: data.columnInfo?.name || '',
      prompt: data.columnInfo?.prompt || '',
      desc: data.columnInfo?.desc || '',
      setting: data.columnInfo?.setting || '',
      fieldCode: data.columnInfo?.fieldCode || '',
      fieldType: !isNullOrUndefOrEmpty(data.columnInfo?.fieldType)
        ? data.columnInfo?.fieldType
        : '',
      fieldIdentity: data.columnInfo?.fieldIdentity || getUuid(),
      dataType: data.columnInfo?.dataType || '',
      defaultMark: data.columnInfo?.defaultMark || 0,
      defaultValue: data.columnInfo?.defaultValue || '',
      precisions: data.columnInfo?.precisions || '',
      minValue: data.columnInfo?.minValue || '',
      maxValue: data.columnInfo?.maxValue || '',
      minLength: data.columnInfo?.minLength || '',
      maxLength: data.columnInfo?.maxLength || '',
      encryptType: data.columnInfo?.encryptType || 0,
      columnOperateList: data.columnInfo?.columnOperateList || [],
      //@ts-ignore
      columnQuoteInfo: data.columnInfo?.columnQuoteInfo || null,
      conditionList: data.columnInfo?.conditionList || [],
      defaultValueConfigInfo: data.columnInfo?.defaultValueConfigInfo || {},
      fieldSerial: data.columnInfo?.fieldSerial || '',
      columnDataList: data.columnInfo?.columnDataList || [],
      //@ts-ignore
      dataMark: !isNullOrUndefOrEmpty(data.columnInfo?.dataMark) ? data.columnInfo?.dataMark : '',
      visibleRuleList: data.columnInfo?.visibleRuleList || [],
      unit: data.columnInfo?.unit || '',
      //@ts-ignore
      unionTableColumnInfo: data.columnInfo?.unionTableColumnInfo || null,
      //@ts-ignore
      columnConfig: data.columnInfo?.columnConfig || null,
      fieldApi: data.columnInfo?.fieldApi || ''
    }
  }
}

export function getContainerBlankData(subData: SubType) {
  console.log(subData, 'subData1111')
  return {
    id: 0,
    parentId: 0,
    positionId: subData.positionId,
    title: '空容器',
    code: 'BLANK',
    defineType: 20,
    layout: '{}',
    children: [],
    modules: [
      {
        id: subData.id || 0,
        tableCode: subData.tableCode,
        positionId: subData.positionId,
        containerId: 0,
        title: subData.title || '',
        desc: '',
        moduleType: subData.moduleType || 0,
        defineType: 20,
        layout:
          subData.moduleType === moduleType.subForm
            ? JSON.stringify({ position: { x: 0 }, formStyle: 1 })
            : JSON.stringify({ position: { x: 0 } }),
        componentList: [],
        buttonList: [],
        operateList: [],
        group: String(_randomInt(19)),
        tId: GenNonDuplicateID(3),
        columnTableCode: subData.columnTableCode,
        moduleSerial: String(_randomInt(19))
      }
    ],
    tId: GenNonDuplicateID(3),
    tableCode: subData.tableCode
  }
}
export function getContainerTableData(data: any) {
  console.log(data, '11111')
  return {
    id: 0,
    parentId: 0,
    positionId: data.positionId,
    title: '空容器',
    code: 'TABLE',
    defineType: 20,
    layout: '{}',
    children: [
      {
        id: 0,
        parentId: 0,
        title: 'table1',
        code: 'MODULE',
        defineType: 20,
        layout: '{}',
        children: null,
        modules: [],
        tId: GenNonDuplicateID(3),
        tableCode: data.tableCode,
        positionId: data.positionId
      },
      {
        id: 0,
        parentId: 0,
        title: 'table2',
        code: 'MODULE',
        defineType: 20,
        layout: '{}',
        children: null,
        modules: [],
        tId: GenNonDuplicateID(3),
        tableCode: data.tableCode,
        positionId: data.positionId
      },
      {
        id: 0,
        parentId: 0,
        title: 'table3',
        code: 'MODULE',
        defineType: 20,
        layout: '{}',
        children: null,
        modules: [],
        tId: GenNonDuplicateID(3),
        tableCode: data.tableCode,
        positionId: data.positionId
      }
    ],
    modules: [],
    tId: GenNonDuplicateID(3),
    tableCode: data.tableCode
  }
}

export function getTableData(subData: SubType) {
  console.log(subData, 'subData')
  return {
    id: 0,
    tableCode: subData.tableCode,
    containerId: subData.id || 0,
    positionId: subData.positionId,
    title: subData.title || '',
    desc: '',
    moduleType: subData.moduleType || 0,
    defineType: 20,
    layout: '{}',
    componentList: [],
    group: String(_randomInt(19)),
    tId: GenNonDuplicateID(3),
    columnTableCode: subData.columnTableCode,
    moduleSerial: String(_randomInt(19)),
    buttonList: []
  }
}

export function getBtnData(data: Recordable) {
  return {
    desc: '',
    tId: GenNonDuplicateID(3),
    actionCode: '',
    actionValue: '',
    alertCode: 'NEW_TAB',
    code: String(_randomInt(19)),
    defineType: data.defineType, // 按钮是自定义还是预定义
    id: 0,
    moduleSerial: data.moduleSerial,
    reqType: '',
    sceneType: data.sceneType, // 使用场景，按钮配在不同的位置会变化的，分栏右边用11
    sort: 0,
    tableCode: data.tableCode,
    tenantId: '',
    title: '按钮',
    url: '',
    value: true,
    extraSetting: '{}',
    buttonSerial: String(_randomInt(19)),
    visibleList: []
  }
}

/**
 * @author：张胜
 * @desc：控制默认配置是否显示
 * */
export const defaultShowFlagConfig = {
  showImport: true, // 是否导入
  showExport: true, // 是否导出
  showTableList: true, // 是否列表展示
  showLayoutWidth: true, // 是否展示字段占比
  showTip: true, // 是否展示提示文字
  showDefault: true, // 是否展示默认值
  showRequired: true, // 是否必填
  showDesensitization: false, // 是否展示脱敏
  showRepeat: false, // 是否展示 是否允许重复
  showTime: false // 是否展示 是否显示时间
}

// 获取布局的场景
export const columnUseSceneEnums = {
  listPage: 1, // 列表页面字段标题
  addPage: 2, // 新增数据页面
  editPage: 3, // 编辑数据页面
  detailPage: 4, // 详情数据页面
  addLayout: 5, // 新增布局页面
  detailLayout: 6, // 详情布局页面
  processBranch: 7, // 流程分支条件
  processAssist: 8, // 流程详情字段
  processDetailPage: 9, // 流程详情数据详情页面
  pageTitle: 10, // 表格表头字段
  pageSearch: 11 // 快捷搜索字段
}

// ("使用场景 0: 其他人员部门组件场景; 1：客户管理移交; 2：公海列表分配; 3: paas表单; 4: 回收规则; 5: 自定义返回人员部门; 6: 协助人; 7: 个人账户授权")
// 人员组件使用场景
export const useSceneTypeEnums = {
  other: 0,
  transfer: 1,
  highSea: 2,
  paas: 3,
  recycle: 4,
  custom: 5,
  helper: 6,
  revoke: 7
}

/**
 * @author：张胜
 * @desc：字段库
 * @todo dataClass记得处理
 * */
export const libraryList: libraryListType[] = [
  {
    title: '输入框组件',
    children: [
      {
        value: fieldTypeConfig.singleLineText,
        label: '单行文本',
        icon: 'leixingshanxingwenbenactiveno',
        dataClass: allFieldDataClass.SingleLineText,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.multilineText,
        label: '多行文本',
        icon: 'leixingduoxingwenbenactiveno',
        dataClass: allFieldDataClass.MultilineText,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.money,
        label: '金额',
        icon: 'leixingjineactiveno',
        dataClass: allFieldDataClass.Money,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.percentage,
        label: '百分比',
        icon: 'leixingmofenbiactiveno',
        dataClass: allFieldDataClass.Percent,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.number,
        label: '数字',
        icon: 'leixingshuziactiveno',
        dataClass: allFieldDataClass.Numbers,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.phone,
        label: '手机',
        icon: 'leixingshoujiactiveno',
        dataClass: allFieldDataClass.Phone,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.creditCode,
        label: '统一社会信用代码',
        icon: 'leixingxinyongdaimaactiveno',
        dataClass: allFieldDataClass.CreditCode,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'fullLine'
      },
      {
        value: fieldTypeConfig.idCard,
        label: '身份证号',
        icon: 'leixingshenfenzhengactiveno',
        dataClass: allFieldDataClass.IdCard,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.email,
        label: '邮箱地址',
        icon: 'leixingyouxiangdezhiactiveno',
        dataClass: allFieldDataClass.Email,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.landline,
        label: '座机号',
        icon: 'leixingzuojiactiveno',
        dataClass: allFieldDataClass.Landline,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.serial,
        label: '流水号',
        icon: 'leixingyouzhengbianmaactiveno',
        dataClass: allFieldDataClass.Serial,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      }
      // {
      //   value: fieldTypeConfig.postalCode,
      //   label: '邮政编码',
      //   icon: 'icon-wenben',
      //   dataClass: allFieldDataClass.PostalCode,
      //   layoutShow: true,
      //   dropSize: 'default',
      //   widthSize: 'halfLine'
      // }
    ]
  },
  {
    title: '日期',
    children: [
      {
        value: fieldTypeConfig.date1,
        label: '日期',
        icon: 'leixingrijishijianactiveno',
        dataClass: allFieldDataClass.Dates1,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.date2,
        label: '日期区间',
        icon: 'leixingrijishijianactiveno',
        dataClass: allFieldDataClass.Dates2,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.date3,
        label: '时间',
        icon: 'leixingtimeactiveno',
        dataClass: allFieldDataClass.Dates3,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      }
    ]
  },
  {
    title: '选择器',
    children: [
      {
        value: fieldTypeConfig.radio,
        label: '单选按钮',
        icon: 'leixingradioactiveno',
        dataClass: allFieldDataClass.SingleRadio,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.checkbox,
        label: '复选按钮',
        icon: 'leixingfuxuanactiveno',
        dataClass: allFieldDataClass.MultipleCheckbox,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.select,
        label: '下拉单选框',
        icon: 'leixingxialashanxuanactiveno',
        dataClass: allFieldDataClass.Select,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.multipleChoice,
        label: '下拉复选框',
        icon: 'leixingxialafuxuanactiveno',
        dataClass: allFieldDataClass.MultipleChoice,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.department,
        label: '部门单选',
        icon: 'leixingbumenshanxuanactiveno',
        dataClass: allFieldDataClass.Department,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.multipleDepartment,
        label: '部门多选',
        icon: 'leixingbumenduoxuanactiveno',
        dataClass: allFieldDataClass.MultipleDepartment,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.person,
        label: '成员单选',
        icon: 'leixingchengyunshanxuanactiveno',
        dataClass: allFieldDataClass.Person,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.personMultiple,
        label: '成员多选',
        icon: 'leixingchengyunduoxuanactiveno',
        dataClass: allFieldDataClass.PersonMultiple,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.cascader,
        label: '多级联动',
        icon: 'duojiliandong',
        dataClass: allFieldDataClass.Cascader,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.address,
        label: '地址',
        icon: 'leixingdezhiactiveno',
        dataClass: allFieldDataClass.Address,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      }
    ]
  },
  {
    title: '上传组件',
    children: [
      {
        value: fieldTypeConfig.picture,
        label: '上传图片',
        icon: 'leixingtupianactiveno',
        dataClass: allFieldDataClass.Picture,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.enclosure,
        label: '上传附件',
        icon: 'leixingbujianactiveno',
        dataClass: allFieldDataClass.Enclosure,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      }
    ]
  },
  {
    title: '高级组件',
    children: [
      {
        value: fieldTypeConfig.subField,
        label: '分栏',
        icon: 'fenlan',
        dataClass: allFieldDataClass.SubField,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.subList,
        label: '子表单',
        icon: 'leixingzibiaoshanactiveno',
        dataClass: allFieldDataClass.SubList,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.subTable,
        label: 'table标签页',
        icon: 'leixingtabactiveno',
        dataClass: allFieldDataClass.SubTable,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      // {
      //   value: fieldTypeConfig.partingLine,
      //   label: '分割线',
      //   icon: 'icon-wenben',
      //   dataClass: allFieldDataClass.PartingLine,
      //   layoutShow: true,
      //   dropSize: 'default',
      //   widthSize: 'halfLine'
      // },
      {
        value: fieldTypeConfig.associationQuery,
        label: '关联查询',
        icon: 'leixingguanlianzhaxunactiveno',
        dataClass: allFieldDataClass.AssociationQuery,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.associationForm,
        label: '关联表单',
        icon: 'leixingguanlianzhaxunactiveno',
        dataClass: allFieldDataClass.AssociationForm,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.button,
        label: '按钮',
        icon: 'leixinganniuactiveno',
        dataClass: allFieldDataClass.Button,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      },
      {
        value: fieldTypeConfig.sign,
        label: '签名',
        icon: 'qianming',
        dataClass: allFieldDataClass.Sign,
        layoutShow: true,
        dropSize: 'default',
        widthSize: 'halfLine'
      }
    ]
  }
]

/**
 * @author：张胜
 * @desc：获取控件库显示字段
 * */

export function layoutFieldConfigTypeList(): libraryListType[] {
  libraryList.forEach(item => {
    item.children = item.children.filter(child => child.layoutShow)
  })
  return libraryList
}

export function layoutHighConfigTypeList(): libraryListType[] {
  const list: libraryListType[] = [
    {
      title: '高级组件',
      children: [
        {
          value: fieldTypeConfig.subField,
          label: '分栏',
          icon: 'icon-wenben',
          dataClass: allFieldDataClass.SubField,
          layoutShow: true,
          dropSize: 'default',
          widthSize: 'halfLine'
        },
        {
          value: fieldTypeConfig.subTable,
          label: 'table标签页',
          icon: 'icon-wenben',
          dataClass: allFieldDataClass.SubTable,
          layoutShow: true,
          dropSize: 'default',
          widthSize: 'halfLine'
        },
        // {
        //   value: fieldTypeConfig.partingLine,
        //   label: '分割线',
        //   icon: 'icon-wenben',
        //   dataClass: allFieldDataClass.PartingLine,
        //   layoutShow: true,
        //   dropSize: 'default',
        //   widthSize: 'halfLine'
        // },
        {
          value: fieldTypeConfig.associationForm,
          label: '关联表单',
          icon: 'icon-wenben',
          dataClass: allFieldDataClass.AssociationForm,
          layoutShow: true,
          dropSize: 'default',
          widthSize: 'halfLine'
        },
        {
          value: fieldTypeConfig.button,
          label: '按钮',
          icon: 'icon-wenben',
          dataClass: allFieldDataClass.Button,
          layoutShow: true,
          dropSize: 'default',
          widthSize: 'halfLine'
        }
      ]
    }
  ]
  list.forEach(item => {
    item.children = item.children.filter(child => child.layoutShow)
  })
  return list
}

export function layoutFieldPropertyToFieldDataClass() {
  const map: Record<string, any> = {}
  libraryList.forEach(item => {
    console.log(item, 'item123333')
    if (item.children.length) {
      item.children.forEach(sub => {
        map[sub.value] = sub.dataClass
      })
    }
    // 添加业务组件
    map[fieldTypeConfig.tags] = allFieldDataClass.Tags
    // 添加业务组件
    map[fieldTypeConfig.referralPerson] = allFieldDataClass.ReferralPerson
    // 添加业务组件
    map[fieldTypeConfig.referralPersonSource] = allFieldDataClass.ReferralPersonSource
  })
  console.log(map, 'map999')
  return map
}

/**
 * @author：张胜
 * @desc：根据字段类型渲染组件
 * @todo
 * */
const renderFieldComp: Record<string, Fn> = {}
export const fieldCompFnMap = (renderFieldComp: Record<string, Fn>) => {
  ;[fieldTypeConfig.singleLineText, fieldTypeConfig.multilineText].forEach(i => {
    renderFieldComp[i] = () => 'InputConfig'
  })
  ;[fieldTypeConfig.money].forEach(i => {
    renderFieldComp[i] = () => 'MoneyConfig'
  })
  ;[fieldTypeConfig.percentage, fieldTypeConfig.number].forEach(i => {
    renderFieldComp[i] = () => 'PercentageConfig'
  })
  ;[fieldTypeConfig.phone].forEach(i => {
    renderFieldComp[i] = () => 'PhoneConfig'
  })
  ;[
    fieldTypeConfig.creditCode,
    fieldTypeConfig.idCard,
    fieldTypeConfig.email,
    fieldTypeConfig.landline
  ].forEach(i => {
    renderFieldComp[i] = () => 'CreditCodeConfig'
  })
  ;[fieldTypeConfig.serial].forEach(i => {
    renderFieldComp[i] = () => 'SerialConfig'
  })
  ;[fieldTypeConfig.date1, fieldTypeConfig.date2, fieldTypeConfig.date3].forEach(i => {
    renderFieldComp[i] = () => 'DateConfig'
  })
  ;[fieldTypeConfig.radio].forEach(i => {
    renderFieldComp[i] = () => 'RadioConfig'
  })
  ;[fieldTypeConfig.checkbox].forEach(i => {
    renderFieldComp[i] = () => 'CheckboxConfig'
  })
  ;[fieldTypeConfig.select].forEach(i => {
    renderFieldComp[i] = () => 'SelectConfig'
  })
  ;[fieldTypeConfig.multipleChoice].forEach(i => {
    renderFieldComp[i] = () => 'MultipleChoiceConfig'
  })
  ;[fieldTypeConfig.department].forEach(i => {
    renderFieldComp[i] = () => 'DepartmentConfig'
  })
  ;[fieldTypeConfig.picture].forEach(i => {
    renderFieldComp[i] = () => 'PictureConfig'
  })
  ;[fieldTypeConfig.enclosure].forEach(i => {
    renderFieldComp[i] = () => 'EnclosureConfig'
  })
  ;[fieldTypeConfig.associationQuery].forEach(i => {
    renderFieldComp[i] = () => 'AssociationQueryConfig'
  })
  // [fieldTypeConfig.associationForm].forEach(i => {
  //   renderFieldComp[i] = () => 'AssociationFormConfig'
  // });
  ;[fieldTypeConfig.subField].forEach(i => {
    renderFieldComp[i] = () => 'SubFieldConfig'
  })
  ;[fieldTypeConfig.address].forEach(i => {
    renderFieldComp[i] = () => 'AddressConfig'
  })
  ;[fieldTypeConfig.sign].forEach(i => {
    renderFieldComp[i] = () => 'SignConfig'
  })
  ;[fieldTypeConfig.cascader].forEach(i => {
    renderFieldComp[i] = () => 'CascaderConfig'
  })
  ;[fieldTypeConfig.person].forEach(i => {
    renderFieldComp[i] = () => 'PersonConfig'
  })
  ;[fieldTypeConfig.partingLine].forEach(i => {
    renderFieldComp[i] = () => 'PartingLineConfig'
  })
  ;[fieldTypeConfig.tags].forEach(i => {
    renderFieldComp[i] = () => 'TagsConfig'
  })
  ;[fieldTypeConfig.personMultiple].forEach(i => {
    renderFieldComp[i] = () => 'PersonMultipleConfig'
  })
  ;[fieldTypeConfig.multipleDepartment].forEach(i => {
    renderFieldComp[i] = () => 'MultipleDepartmentConfig'
  })
  ;[fieldTypeConfig.referralPerson].forEach(i => {
    renderFieldComp[i] = () => 'ReferralPersonConfig'
  })
  ;[fieldTypeConfig.referralPersonSource].forEach(i => {
    renderFieldComp[i] = () => 'ReferralPersonSourceConfig'
  })

  return renderFieldComp
}

export const formTypeRelatePropertyStrategy = fieldCompFnMap(renderFieldComp)
const defaultFormTypeRelatePropertyStrategy = () => 'InputConfig'
// 获取应展示组件的类型
export const getComponentType = (data: dragFieldData): string => {
  let res = ''
  const fieldProperty = data.fieldProperty
  const strategy =
    formTypeRelatePropertyStrategy[fieldProperty] || defaultFormTypeRelatePropertyStrategy
  res = strategy()
  return res
}

// 字段初始值
// export const initData = {
//   id: 0,
//   tableCode: 0,
//   positionId: 0,
//   containerId: 0,
//   moduleId: 0,
//   columnId: 0,
//   code: '',
//   moduleType: 0,
//   defineType: 0,
//   name: '',
//   prompt: '',
//   desc: '',
//   setting: '',
//   layout: '',
//   columnInfo: {},
//   componentOperateList: [], // 如果是接口返回，那我自定义字段，这个配置咋配，明天来问
//   tId: GenNonDuplicateID(3)
// }
export const initData = () => {
  return {
    id: 0,
    tableCode: 0,
    positionId: 0,
    containerId: 0,
    moduleId: 0,
    columnId: 0,
    code: '',
    moduleType: 0,
    defineType: 0,
    name: '',
    prompt: '',
    desc: '',
    setting: '',
    layout: '',
    columnInfo: {},
    componentOperateList: [], // 如果是接口返回，那我自定义字段，这个配置咋配，明天来问
    tId: GenNonDuplicateID(3)
  }
}

/**
 * @author：张胜
 * @desc：自增标号时间转换成名字
 * */
export const timeTurnName = (str: any) => {
  if (str) {
    str = str.replace(/\{yyyy\}/g, () => {
      return new Date().getFullYear()
    })
    str = str.replace(/\{mm\}/g, () => {
      const month = new Date().getMonth() + 1
      return month >= 10 ? month : '0' + month
    })
    str = str.replace(/\{dd\}/g, () => {
      const day = new Date().getDate()
      return day >= 10 ? day : '0' + day
    })
    return str
  }
  return ''
}
// 自增编号的重新计算规则选项列表
export const recalculationRuleList = [
  { value: 0, label: '不重新计算' },
  { value: 1, label: '按年重新计算' },
  { value: 2, label: '按年,月重新计算' },
  { value: 3, label: '按年,月,日重新计算' }
]
function handleDate4Params(field: Recordable) {
  return {
    compName: customCompNameEnums.date5,
    dateFormat: 'YYYY-MM-DD',
    timeFormat: 'HH:mm:ss',
    type: 'daterange',
    placeholder: '请选择',
    startDatePlaceholder: '开始日期',
    endDatePlaceholder: '结束日期',
    startTimePlaceholder: '开始时间',
    endTimePlaceholder: '结束时间',
    val: field?.val || [
      [null, null],
      [null, null]
    ],
    disabled: false
  }
}
// 过滤筛选计算规则
export function filterRuleList(value: any): List[] {
  let res
  const str = String(value)
  const yearStr = '{yyyy}'
  const monthStr = '{mm}'
  const dayStr = '{dd}'
  if (str.includes(yearStr) && str.includes(monthStr) && str.includes(dayStr)) {
    // 年, 月, 日
    res = recalculationRuleList.slice()
  } else if (str.includes(yearStr) && str.includes(monthStr)) {
    // 年, 月
    res = recalculationRuleList.slice(0, 3)
  } else if (str.includes(yearStr)) {
    // 年 (年, 日)
    res = recalculationRuleList.slice(0, 2)
  } else {
    res = recalculationRuleList.slice(0, 1)
  }
  return res
}
const conditions: Record<string, Fn> = {}
export function getCondition(conditions: Record<string, Fn>) {
  ;[
    fieldTypeConfig.singleLineText,
    fieldTypeConfig.phone,
    fieldTypeConfig.idCard,
    fieldTypeConfig.creditCode,
    fieldTypeConfig.email,
    fieldTypeConfig.landline,
    fieldTypeConfig.serial,
    fieldTypeConfig.multilineText,
    fieldTypeConfig.sign
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '等于',
        value: conditionEnum.equal
      },
      {
        label: '不等于',
        value: conditionEnum.unequal
      },
      {
        label: '包含',
        value: conditionEnum.contain
      },
      {
        label: '不包含',
        value: conditionEnum.exclusive
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.sign // isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.number, // gt,lt,gte,lte,equal,ne,between,isnull,notnull
    fieldTypeConfig.money, // gt,lt,gte,lte,equal,ne,between,isnull,notnull
    fieldTypeConfig.percentage // gt,lt,gte,lte,equal,ne,between,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '等于',
        value: conditionEnum.equal
      },
      {
        label: '不等于',
        value: conditionEnum.ne
      },
      {
        label: '大于',
        value: conditionEnum.gt
      },
      {
        label: '小于',
        value: conditionEnum.lt
      },
      {
        label: '大于等于',
        value: conditionEnum.gte
      },
      {
        label: '小于等于',
        value: conditionEnum.lte
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      },
      {
        label: '介于',
        value: conditionEnum.between
      }
    ]
  })
  ;[
    fieldTypeConfig.date1, // equal,interval,isnull,notnull
    fieldTypeConfig.date3 // equal,interval,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '等于',
        value: conditionEnum.equal
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.date2 //  range_equal,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '区间等于',
        value: conditionEnum.range_equal
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.address // contain,exclusive,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '包含',
        value: conditionEnum.contain
      },
      {
        label: '不包含',
        value: conditionEnum.exclusive
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.cascader // match,mismatch,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '匹配',
        value: conditionEnum.match
      },
      {
        label: '不匹配',
        value: conditionEnum.mismatch
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.radio, // in,notin,isnull,notnull
    fieldTypeConfig.select, // in,notin,isnull,notnull
    fieldTypeConfig.person, // in,notin,isnull,notnull
    fieldTypeConfig.department, // in,notin,isnull,notnull
    fieldTypeConfig.guarantee,
    fieldTypeConfig.erpProduct
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '包含',
        value: conditionEnum.in
      },
      {
        label: '不包含',
        value: conditionEnum.notin
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[
    fieldTypeConfig.checkbox,
    fieldTypeConfig.multipleChoice, // in_set,not_in_set,isnull,notnull
    fieldTypeConfig.personMultiple, // in_set,not_in_set,isnull,notnull
    fieldTypeConfig.multipleDepartment // in_set,not_in_set,isnull,notnull
  ].forEach(i => {
    conditions[i] = () => [
      {
        label: '包含',
        value: conditionEnum.in_set
      },
      {
        label: '不包含',
        value: conditionEnum.not_in_set
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  ;[fieldTypeConfig.tags].forEach(i => {
    conditions[i] = () => [
      {
        label: '包含',
        value: conditionEnum.json_inset
      },
      {
        label: '不包含',
        value: conditionEnum.json_not_inset
      },
      {
        label: '为空',
        value: conditionEnum.isnull
      },
      {
        label: '不为空',
        value: conditionEnum.notnull
      }
    ]
  })
  return conditions
}

export const formTypeStrategyCondition = getCondition(conditions)
const defaultFormTypeStrategyCondition = () => []
// 获取应展示组件的类型
export const getConditionType = (code: string): List[] => {
  let res = []
  const strategy = formTypeStrategyCondition[code] || defaultFormTypeStrategyCondition
  res = strategy()
  return res
}

export function getFieldType() {
  // 字段类别 0-原表已有字段
  // 10-系统引用字段
  // 11-自定义关联字段
  // 20-系统映射字段
  // 21-自定义映射字段
  // 50-子表原有字段
  // 51-子表自定义字段
  // 60-子表系统关联字段
  // 61-子表自定义关联字段
  // 70-子表系统映射字段
  // 71-子表自定义映射字段
  // 100-表单字段
  // 1000-自定义扩展字段
}

// 是否显示删除图标
export function showDelete(data: FieldType) {
  return (
    data.fieldType === 11 ||
    data.fieldType === 21 ||
    data.fieldType === 51 ||
    data.fieldType === 61 ||
    data.fieldType === 71 ||
    data.fieldType === 1000
  )
}
export const getTableColumnWidthByCode = (key: string) => {
  return 0
  // switch (key) {
  //   case fieldTypeConfig.date3:
  //   case fieldTypeConfig.number:
  //   case fieldTypeConfig.money:
  //     return 160
  //   case fieldTypeConfig.date1:
  //     return 200
  //   case fieldTypeConfig.date2:
  //     return 350
  //   case fieldTypeConfig.address:
  //     return 220
  //   default:
  //     return 0
  // }
}

// 快捷筛选，高级筛选
export function createFilterOperateConfig(states: Recordable) {
  ;[
    fieldTypeConfig.singleLineText, // 单行文本
    fieldTypeConfig.multilineText, // 多行文本
    fieldTypeConfig.phone, // 手机号
    fieldTypeConfig.landline, // 座机号
    fieldTypeConfig.idCard, // 身份证号
    fieldTypeConfig.creditCode, // 统一社会信用代码
    fieldTypeConfig.email // 邮箱地址
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      // console.log(field, 'field2221')
      let maxlength = 50
      switch (field.code) {
        case fieldTypeConfig.phone:
          maxlength = 11
          break
      }
      return {
        compName: customCompNameEnums.input,
        maxlength: maxlength,
        class: 'filter-search-input',
        placeholder: field.prompt || '请输入',
        val: field.val || '',
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.date1 // 日期
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      // console.log(field, '回显date1', field.val)
      let format = 'YYYY-MM-DD HH:mm:ss'
      let type = 'datetime'
      const val = ''
      if (field.precisions === 1 || field.precisions === 0) {
        format = 'YYYY-MM-DD HH:mm:ss'
        type = field.condition === 'interval' ? 'datetimerange' : 'datetime'
      }
      if (field.precisions === 2) {
        format = 'YYYY-MM-DD'
        type = field.condition === 'interval' ? 'daterange' : 'date'
      }
      if (field.precisions === 3) {
        format = 'YYYY-MM'
        type = field.condition === 'interval' ? 'monthrange' : 'month'
      }
      if (field.precisions === 4) {
        format = 'YYYY'
        type = 'year'
      }
      if (field.condition === 'date_interval') {
        return handleDate4Params(field)
      }
      const dateComponentMap = {
        dynamic_date: customCompNameEnums.quickTime,
        interval: customCompNameEnums.date2,
        default: customCompNameEnums.date1
      }
      return {
        compName:
          dateComponentMap[field.condition as keyof typeof dateComponentMap] ||
          dateComponentMap.default,
        format,
        type,
        placeholder: '请选择',
        val: field.val || (field.condition === 'interval' ? [] : val),
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.date2 // 日期区间
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      console.log(field, 'eeee')
      let format = 'YYYY-MM-DD HH:mm:ss'
      let type = 'datetimerange'
      const val: any[] = []
      if (field.precisions === 1 || field.precisions === 0) {
        format = 'YYYY-MM-DD HH:mm:ss'
        type = 'datetimerange'
      }
      if (field.precisions === 2) {
        format = 'YYYY-MM-DD'
        type = 'daterange'
      }
      if (field.precisions === 3) {
        format = 'YYYY-MM'
        type = 'monthrange'
      }
      if (field.condition === 'date_interval') {
        return handleDate4Params(field)
      }
      return {
        compName: customCompNameEnums.date2,
        format,
        type,
        placeholder: '请选择',
        val: field.val || val,
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.date3 // 时间
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      console.log(field, 'eeee')
      let format = 'HH:mm:ss'
      let valueFormat = 'HH:mm:ss'
      const val = ''
      if (field.precisions === 1 || field.precisions === 0) {
        format = 'HH:mm:ss'
        valueFormat = 'HH:mm:ss'
      }
      if (field.precisions === 2) {
        format = 'HH:mm'
        valueFormat = 'HH:mm'
      }
      if (field.condition === 'date_interval') {
        return handleDate4Params(field)
      }
      // if (field.precisions === 3) {
      //   format = 'YYYY-MM'
      // }
      return {
        compName:
          field.condition === 'interval' ? customCompNameEnums.date3Gai : customCompNameEnums.date3,
        format,
        valueFormat,
        placeholder: '请选择',
        val: field.val || (field.condition === 'interval' ? [] : val),
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.select, // 下拉单选
    fieldTypeConfig.radio, // 单选按钮
    fieldTypeConfig.multipleChoice, // 下拉多选
    fieldTypeConfig.checkbox // 复选框
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.multipleSelect,
        placeholder: field.prompt || '请选择',
        multiple: true,
        dataList: field.dataList || [],
        val: field.val || [],
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.number, // 数字
    fieldTypeConfig.money, // 金额
    fieldTypeConfig.percentage // 百分比
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      // console.log(field, 'field1112')
      return {
        compName:
          field.condition === conditionEnum.between || field.condition === conditionEnum.interval
            ? customCompNameEnums.inputGai
            : customCompNameEnums.input,
        maxlength: 50,
        class: 'filter-search-input',
        placeholder: field.prompt || '请输入',
        disabled: false,
        val:
          field.val ||
          (field.condition === conditionEnum.between || field.condition === conditionEnum.interval
            ? []
            : '')
      }
    }
  })
  ;[
    fieldTypeConfig.cascader // 多级联动
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.cascade,
        placeholder: field.prompt || '请选择',
        multiple: false,
        dataList: field.dataList || [],
        val: field.val || '',
        disabled: false
      }
    }
  })
  ;[
    fieldTypeConfig.personMultiple, // 人员多选
    fieldTypeConfig.person // 人员单选
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      // console.log(field, 'field1112')
      return {
        compName: customCompNameEnums.personMultiple,
        class: 'filter-search-input',
        val: field.val || [],
        placeholder: field.prompt || '请选择',
        disabled: false
      }
    }
  })
  // [
  //   fieldTypeConfig.person // 人员单选
  // ].forEach(key => {
  //   states[key] = (field: Recordable) => {
  //     console.log(field, '人员单选field')
  //     return {
  //       compName: customCompNameEnums.person,
  //       class: 'filter-search-input',
  //       val: field.val || [],
  //       placeholder: field.prompt || '请选择',
  //       disabled: false
  //     }
  //   }
  // });
  ;[
    fieldTypeConfig.multipleDepartment, // 部门多选
    fieldTypeConfig.department // 部门单选
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.multipleDepartment,
        class: 'filter-search-input',
        val: field.val || [],
        placeholder: field.prompt || '请选择',
        disabled: false
      }
    }
  })
  // [
  //   fieldTypeConfig.department // 部门单选
  // ].forEach(key => {
  //   states[key] = (field: Recordable) => {
  //     return {
  //       compName: customCompNameEnums.department,
  //       class: 'filter-search-input',
  //       val: field.val || [],
  //       placeholder: field.prompt || '请选择',
  //       disabled: false
  //     }
  //   }
  // });
  ;[
    fieldTypeConfig.tags // 客户标签
  ].forEach(key => {
    states[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.tags,
        val: field.val || [],
        placeholder: field.prompt || '请选择',
        disabled: false
      }
    }
  })
  return states
}
const searchObj: Recordable = {}
export const filterOperateConfig = createFilterOperateConfig(searchObj)

const filterObj: Recordable = {}
function handleDate4Value(value: any) {
  const [startDate, endDate, startTime, endTime] = value.split(',')

  console.log('data444', value, '日期区间', startDate, endDate, '时间区间', startTime, endTime)

  let str = ''
  if (startDate) {
    str += `${startDate}--${endDate || ''}`
  }
  if (startTime) {
    str += `${str ? ' 每日' : ''}${startTime}--${endTime || ''}`
  }
  return str.trim() || ''
}
function createFilterLabelStrategy(filterObj: Recordable) {
  ;[
    fieldTypeConfig.select,
    fieldTypeConfig.radio,
    fieldTypeConfig.multipleChoice,
    fieldTypeConfig.checkbox
  ].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      const value = form[code]
      const tempValueArr = value
        ? String(value)
            ?.split?.(',')
            ?.map((i: any) => String(i))
        : []
      console.log(tempValueArr, 'tempValueArr222', data)
      const dataList = data.renderConfig.dataList || []
      const tempArr: any[] = []
      dataList.forEach((i: List) => {
        const index = tempValueArr.indexOf(String(i.value))
        console.log(index, 'index111')
        if (index > -1) {
          tempArr.push(i.label)
        }
      })
      return tempArr.join(',')
    }
  })
  ;[
    fieldTypeConfig.person, // 成员单选
    fieldTypeConfig.personMultiple // 成员多选
  ].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      console.log(data.dataList, 'KKK')
      const value = form[code]
      const dataList = data.renderConfig.dataList || []
      const tempValueArr = value ? value?.split?.(',')?.map((i: any) => String(i)) : []
      console.log(tempValueArr, 'tempValueArrKKK', dataList)

      const tempArr: any[] = []
      dataList &&
        dataList.forEach((i: Recordable) => {
          if (tempValueArr.includes(i.id)) {
            tempArr.push(i.realName)
          }
        })
      return tempArr.join(',')
    }
  })
  ;[
    fieldTypeConfig.department, // 部门单选
    fieldTypeConfig.multipleDepartment // 部门多选
  ].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      const value = form[code]
      const dataList = data.renderConfig.dataList || []
      const tempValueArr = value ? value?.split?.(',')?.map((i: any) => String(i)) : []
      const tempArr: any[] = []
      console.log(dataList, 'dataList22')
      dataList &&
        dataList.forEach((i: List) => {
          const index = tempValueArr.indexOf(String(i.id))
          console.log(index, 'index999')
          if (index > -1) {
            tempArr.push(i.name)
          }
        })
      return tempArr.join(',')
    }
  })
  ;[fieldTypeConfig.cascader].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      console.log(data, form, code, 'ppo')
      const value = isString(form[code]) ? form[code].split(',') : []
      const tempArr: string[] = []
      const dataList = data.renderConfig.dataList || []
      // 目前只知道客户阶段是级联
      if (data.dataMark === 2) {
        console.log(value, 'value213', dataList)
        dataList.forEach((i: any) => {
          const index = value.indexOf(String(i.stageValue))
          console.log(index, 'index444')
          if (index > -1) {
            if (i.childStage && i.childStage.length) {
              i.childStage.forEach((sub: any) => {
                const index = value.indexOf(String(sub.stageValue))
                if (index > -1) {
                  tempArr[index] = sub.stageName
                }
              })
            }
            tempArr[index] = i.stageName
          }
        })
      } else {
        dataList.forEach((i: { value: string; label: string }) => {
          const index = value.indexOf(i.value)
          if (index > -1) {
            tempArr[index] = i.label
          }
        })
      }
      console.log(tempArr, 'tempArr23')
      return tempArr.length ? tempArr.join('-') : '-'
    }
  })
  // 日期
  ;[fieldTypeConfig.date3].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      const value = form[code]
      console.log(data, 'data333')
      if (data?.condition === 'date_interval') {
        return handleDate4Value(value)
      }
      return value ? (data.conditionValue === 'interval' ? value.split(',').join('-') : value) : '-'
    }
  })
  ;[fieldTypeConfig.date1].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      const value = form[code]
      return value
        ? data.conditionValue === 'dynamic_date'
          ? quickList.find(item => item.value === value)?.label || ''
          : value
        : '-'
    }
  })
  ;[fieldTypeConfig.tags].forEach(key => {
    filterObj[key] = (data: Recordable, form: Recordable, code: string) => {
      const value = form[code]
      const tempValueArr = value ? value?.split?.(',')?.map((i: any) => String(i)) : []
      const dataList = data.renderConfig.dataList || []
      const tempArr: any[] = []
      dataList.forEach((i: List) => {
        if (i?.tagList?.length) {
          i.tagList.forEach((sub: any) => {
            const index = tempValueArr.indexOf(String(sub.id))
            if (index > -1) {
              tempArr.push(sub.tagName)
            }
          })
        } else {
          const index = tempValueArr.indexOf(String(i.id))
          if (index > -1) {
            tempArr.push(i.tagName)
          }
        }
      })
      return tempArr.join(',')
    }
  })
  return filterObj
}
export const advancedFilterLabelStrategy = createFilterLabelStrategy(filterObj)

// 处理快捷筛选传给后端的值
export function createFastSearchValueStrategy(fasterObj: Recordable) {
  // 下拉多选
  ;[fieldTypeConfig.multipleChoice, fieldTypeConfig.cascader].forEach(key => {
    fasterObj[key] = {
      getVal: (value: any) => {
        return value ? (isArray(value) ? value.map(val => String(val)) : value?.split?.(',')) : []
      },
      clearVal: (field: Recordable) => {
        field.renderConfig.val = []
      }
    }
  })
  // 日期
  ;[fieldTypeConfig.date1].forEach(key => {
    fasterObj[key] = {
      getVal: (value: any, field: any) => {
        if (field.condition === 'interval') return isArray(value) ? value : []
        if (field.condition === 'date_interval') {
          return value
          // return value
        }
        return value ? (isArray(value) ? value.map(val => String(val)).join(',') : value) : []
      },
      clearVal: (field: Recordable) => {
        if (field.condition === 'date_interval') {
          field.renderConfig.val = [
            [null, null],
            [null, null]
          ]
        } else {
          field.renderConfig.val = []
        }
      }
    }
  })
  // 日期区间
  ;[fieldTypeConfig.date2].forEach(key => {
    fasterObj[key] = {
      getVal: (value: any, field: any) => {
        if (field.condition === 'interval') return isArray(value) ? value : []
        return value ? (isArray(value) ? value.map(val => String(val)).join(',') : value) : []
      },
      clearVal: (field: Recordable) => {
        field.renderConfig.val = []
      }
    }
  })
  // 时间
  ;[fieldTypeConfig.date3].forEach(key => {
    fasterObj[key] = {
      getVal: (value: any) => {
        return value
        // return value ? getTime(value) : []
      },
      clearVal: (field: Recordable) => {
        if (field.condition === 'date_interval') {
          field.renderConfig.val = [
            [null, null],
            [null, null]
          ]
        } else {
          field.renderConfig.val = ''
        }
      }
    }
  })
  // 金额
  ;[fieldTypeConfig.money, fieldTypeConfig.percentage, fieldTypeConfig.number].forEach(key => {
    fasterObj[key] = {
      getVal: (value: any, field: Recordable) => {
        if (
          field.condition === conditionEnum.between ||
          field.condition === conditionEnum.interval
        ) {
          return value
            ? [value[0] !== '' ? Number(value[0]) : null, value[1] !== '' ? Number(value[1]) : null]
            : []
        } else {
          return Number(value)
        }
      },
      clearVal: (field: Recordable) => {
        if (
          field.condition === conditionEnum.between ||
          field.condition === conditionEnum.interval
        ) {
          field.renderConfig.val = []
        } else {
          field.renderConfig.val = ''
        }
      }
    }
  })
  return fasterObj
}
const fasterObj: Recordable = {}
export const dealFastSearchValueConfig = createFastSearchValueStrategy(fasterObj)

const tableObj = {}
// 处理表格回显值
export function createTableValueStrategy(tableObj: Recordable) {
  // 单选下拉框，单选按钮
  ;[
    fieldTypeConfig.select,
    fieldTypeConfig.radio,
    fieldTypeConfig.person,
    fieldTypeConfig.referralPerson,
    fieldTypeConfig.referralPersonSource
  ].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      const list = filed.dataList || []
      return filterEnums(String(value), list).label
    }
  })
  // 多选下拉，复选按钮
  ;[
    fieldTypeConfig.multipleChoice,
    fieldTypeConfig.checkbox,
    fieldTypeConfig.personMultiple,
    fieldTypeConfig.department,
    fieldTypeConfig.multipleDepartment
  ].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      const list = filed.dataList || []
      const tempArrValue: any[] = !isNullOrUndefOrEmpty(value)
        ? String(value)
            .split(',')
            .map((val: any) => String(val))
        : []
      let resultArr: Recordable[] = []
      resultArr = list.filter((item: Recordable) => {
        if (tempArrValue?.includes(String(item.value))) {
          return item
        }
      })
      if (resultArr) {
        return resultArr.map((item: Recordable) => item.label).join(',')
      } else {
        return '-'
      }
    }
  })
  // 单行文本，多行文本，手机号，邮箱，邮政编码，描述文字，身份证, 统一社会信用代码，流水号，座机号，金额，数字，百分比，日期
  ;[
    fieldTypeConfig.singleLineText,
    fieldTypeConfig.multilineText,
    fieldTypeConfig.phone,
    fieldTypeConfig.email,
    fieldTypeConfig.postalCode,
    fieldTypeConfig.description,
    fieldTypeConfig.idCard,
    fieldTypeConfig.creditCode,
    fieldTypeConfig.serial,
    fieldTypeConfig.landline,
    fieldTypeConfig.money,
    fieldTypeConfig.number,
    fieldTypeConfig.percentage,
    fieldTypeConfig.date1,
    fieldTypeConfig.date2
  ].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      return value
    }
  })
  // 地址
  ;[fieldTypeConfig.address].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      if (value && isJSON(value)) {
        const getTextValue = () => {
          if (!isJSON(value)) {
            // 如果不是JSON格式就直接返回，不往下执行
            return value
          }
          const { pName = '', cName = '', aName = '', detail } = JSON.parse(value)
          if (filed.precisions === 1) {
            return pName + cName + aName + detail || '-'
          } else if (filed.precisions === 2) {
            return pName + cName + aName || '-'
          } else if (filed.precisions === 3) {
            return pName + cName || '-'
          } else if (filed.precisions === 4) {
            return pName || '-'
          } else {
            return pName + cName + aName + detail || '-'
          }
        }
        return getTextValue()
      } else {
        return value
      }
    }
  })
  // 时间
  ;[fieldTypeConfig.date3].forEach(key => {
    tableObj[key] = (_filed: Recordable, value: any) => {
      return value || '-'
    }
  })
  // 级联
  ;[fieldTypeConfig.cascader].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      console.log(filed, 'filed213213', value)
      return value ? getCascadeLabel(value, filed.dataList) : '-'
    }
  })
  ;[fieldTypeConfig.tags].forEach(key => {
    tableObj[key] = (filed: Recordable, value: any) => {
      console.log(filed, 'filedzckl', value)
      const list = filed.dataList || []
      const tempArrValue: any[] = value ? JSON.parse(value) : []
      let resultArr: Recordable[] = []
      resultArr = list.filter((item: { value: any }) => {
        if (tempArrValue?.includes(String(item.value))) {
          return item
        }
      })
      return resultArr ? resultArr.map(item => item.label).join(',') : '-'
    }
  })
  return tableObj
}

export const dealTableValueConfig = createTableValueStrategy(tableObj)
// 过滤枚举
export const filterEnums = (value: any, enums: Recordable[]) => {
  if (isNullOrUnDef(value) || isEmpty(value) || isNullOrUnDef(enums) || isEmpty(enums)) {
    return {
      value: '-',
      label: '-'
    }
  }
  const tempEnum = (enums as any).find((item: Recordable) => {
    if (String(item.value) === String(value)) return item
  })
  if (tempEnum) {
    return tempEnum
  } else {
    return {
      value: '-',
      label: '-'
    }
  }
}
const formObj = {}
// 处理表单要怎么显示
export function createFormStrategy(formObj: Recordable) {
  ;[
    fieldTypeConfig.singleLineText, // 单行文本
    fieldTypeConfig.multilineText, // 多行文本
    fieldTypeConfig.creditCode, // 社会信用代码
    fieldTypeConfig.percentage, // 百分比
    fieldTypeConfig.number, // 数字
    fieldTypeConfig.idCard // 身份证号
  ].forEach(key => {
    formObj[key] = (field: Recordable) => {
      const obj: Recordable = {
        compName: customCompNameEnums.input,
        maxlength: 50,
        placeholder: field?.prompt || '请输入',
        inputType: 'text'
      }
      switch (field?.code) {
        case fieldTypeConfig.multilineText:
          obj.inputType = 'textarea'
          break
        case fieldTypeConfig.creditCode:
        case fieldTypeConfig.idCard:
          obj.maxlength = 18
          break
        case fieldTypeConfig.percentage:
        case fieldTypeConfig.number:
          obj.maxlength = 10
          break
      }
      return obj
    }
  })
  // 下拉单选
  ;[fieldTypeConfig.select].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.singleSelect,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 单选按钮
  ;[fieldTypeConfig.radio].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.radio,
      placeholder: field.name || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 多选按钮
  ;[fieldTypeConfig.checkbox].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.checkbox,
      placeholder: field.name || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 下拉多选
  ;[fieldTypeConfig.multipleChoice].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.multipleSelect,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 日期
  ;[fieldTypeConfig.date1].forEach(key => {
    formObj[key] = (field: Recordable) => {
      let format = 'YYYY-MM-DD HH:mm:ss'
      let type = 'datetime'
      if (field.precisions === 1 || field.precisions === 0) {
        format = 'YYYY-MM-DD HH:mm:ss'
        type = field.condition === 'interval' ? 'datetimerange' : 'datetime'
      }
      if (field.precisions === 2) {
        format = 'YYYY-MM-DD'
        type = field.condition === 'interval' ? 'daterange' : 'date'
      }
      if (field.precisions === 3) {
        format = 'YYYY-MM'
        type = field.condition === 'interval' ? 'monthrange' : 'month'
      }
      if (field.precisions === 4) {
        format = 'YYYY'
        type = 'year'
      }
      // 时间段的处理
      if (field.condition === 'date_interval') {
        return handleDate4Params(field)
      }
      const dateComponentMap = {
        dynamic_date: customCompNameEnums.quickTime,
        interval: customCompNameEnums.date2,
        default: customCompNameEnums.date1
      }
      return {
        compName:
          dateComponentMap[field.condition as keyof typeof dateComponentMap] ||
          dateComponentMap.default,
        placeholder: field.prompt || '请选择',
        format,
        type
      }
    }
  })
  // 日期区间
  ;[fieldTypeConfig.date2].forEach(key => {
    formObj[key] = (field: Recordable) => {
      let format = 'YYYY-MM-DD HH:mm:ss'
      let type = 'datetimerange'
      if (field.precisions === 1) {
        format = 'YYYY-MM-DD HH:mm:ss'
        type = 'datetimerange'
      }
      if (field.precisions === 2) {
        format = 'YYYY-MM-DD'
        type = 'daterange'
      }
      if (field.precisions === 3) {
        format = 'YYYY-MM'
        type = 'monthrange'
      }
      return {
        compName: customCompNameEnums.date2,
        placeholder: field.prompt || '请选择',
        format,
        type
      }
    }
  })
  // 时间
  ;[fieldTypeConfig.date3].forEach(key => {
    formObj[key] = (field: Recordable) => {
      let format = 'HH:mm:ss'
      let valueFormat = 'HH:mm:ss'
      if (field.precisions === 1) {
        format = 'HH:mm:ss'
        valueFormat = 'HH:mm:ss'
      }
      if (field.precisions === 2) {
        format = 'HH:mm'
        valueFormat = 'HH:mm'
      }
      // if (field.precisions === 3) {
      //   format = 'YYYY-MM-DD YYYY-MM'
      // }

      return {
        compName: customCompNameEnums.date3,
        placeholder: field.prompt || '请选择',
        format,
        valueFormat
      }
    }
  })
  // 自定义区间
  ;[fieldTypeConfig.date4].forEach(key => {
    formObj[key] = (field: Recordable) => {
      let format = 'YYYY-MM-DD HH:mm:ss'
      let type = 'datetimerange'
      if (field.precisions === 1) {
        format = 'YYYY-MM-DD HH:mm:ss'
        type = 'datetimerange'
      }
      if (field.precisions === 2) {
        format = 'YYYY-MM-DD'
        type = 'date'
      }
      if (field.precisions === 3) {
        format = 'YYYY-MM'
        type = 'monthrange'
      }
      return {
        compName: customCompNameEnums.customeDate,
        placeholder: field.name || '请选择',
        valueFormat: 'YYYY-MM-DD',
        format,
        type,
        shortcuts: field.shortcuts
      }
    }
  })
  // 级联
  ;[fieldTypeConfig.cascader].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.cascade,
      placeholder: field.name || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 流水号
  ;[fieldTypeConfig.serial].forEach(key => {
    formObj[key] = (_field: Recordable) => ({
      compName: customCompNameEnums.input,
      placeholder: '自动生成无需填写',
      disabled: true,
      valCallback: (val: string, field: Recordable) => {
        return val ? val : isAssociatedQuery(field.fieldType) ? '' : 'AUTOINCREMENT'
      }
    })
  })
  // 上传图片
  ;[fieldTypeConfig.picture].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.uploadImg,
      placeholder: field.name || '请选择'
    })
  })
  // 上传附件
  ;[fieldTypeConfig.enclosure].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.uploadFile,
      placeholder: field.name || '请选择'
    })
  })
  // 引用字段
  ;[fieldTypeConfig.quote].forEach(key => {
    formObj[key] = (field: Recordable, options?: Recordable, quoteMappingConfig?: QuoteMapping) => {
      const fieldClass = new Quote(field, options)
      quoteMappingConfig?.setQuoteFieldList(field)
      return {
        compName: customCompNameEnums.quote,
        placeholder: field.prompt || '请选择',
        fieldClass,
        valCallback: (val: string) => {
          let v = val
          if (val) {
            const index = String(val).indexOf(globalEnv.specialQuoteFlag)
            v =
              index > -1
                ? String(val).slice(index + globalEnv.specialQuoteFlag.length)
                : String(val)
          }
          return v && v !== 'null' ? v : ''
        }
      }
    }
  })
  // 映射字段
  ;[fieldTypeConfig.mapping].forEach(key => {
    formObj[key] = (field: Recordable, options?: Recordable, quoteMappingConfig?: QuoteMapping) => {
      const fieldClass = new Mapping(field, options)
      quoteMappingConfig?.setMappingFieldList(field)
      return {
        compName: customCompNameEnums.mapping,
        placeholder: field.prompt || '请选择',
        fieldClass,
        valCallback: (val: string) => {
          let v = val
          if (val) {
            const index = String(val).indexOf(globalEnv.specialQuoteFlag)
            v =
              index > -1
                ? String(val).slice(index + globalEnv.specialQuoteFlag.length)
                : String(val)
          }
          return v && v !== 'null' ? v : ''
        }
      }
    }
  })
  // 关联已有数据
  ;[fieldTypeConfig.associatedData].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.associatedData,
        placeholder: field.prompt || '请选择'
      }
    }
  })
  // 关联已有数据
  ;[fieldTypeConfig.tags].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.tags,
        placeholder: field.prompt || '请选择'
      }
    }
  })
  // 地址
  ;[fieldTypeConfig.address].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: field.isCascader ? customCompNameEnums.cascCity : customCompNameEnums.address,
        placeholder: field.prompt || '请选择'
        // valCallback: (val: any, field: Recordable) => {
        //   console.log(val, field)
        //   return '111'
        // }
      }
    }
  })
  ;[
    fieldTypeConfig.personMultiple // 人员多选
  ].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        placeholder: field.prompt || '请选择',
        compName: customCompNameEnums.personMultiple,
        val: field.val || []
      }
    }
  })
  ;[
    fieldTypeConfig.person // 人员单选
  ].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        placeholder: field.prompt || '请选择',
        compName: customCompNameEnums.person,
        val: field.val || []
      }
    }
  })
  ;[
    fieldTypeConfig.multipleDepartment // 部门多选
  ].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        placeholder: field.prompt || '请选择',
        compName: customCompNameEnums.multipleDepartment,
        val: field.val || []
      }
    }
  })
  ;[
    fieldTypeConfig.department // 部门单选
  ].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        placeholder: field.prompt || '请选择',
        compName: customCompNameEnums.department,
        val: field.val || []
      }
    }
  })
  // 手机号
  ;[fieldTypeConfig.phone].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.phone,
        placeholder: field.prompt || '请输入'
      }
    }
  })
  // 金额
  ;[fieldTypeConfig.money].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.money,
        placeholder: field.prompt || '请输入',
        maxlength: 10,
        valCallback: (val: any, field: Recordable) => {
          let value = val
          // switch (field.unit) {
          //   case '万':
          //     value = val * 10000
          //     break
          //   case '千万':
          //     value = val * 10000 * 1000
          //     break
          //   case '角':
          //     value = val * 0.1
          //     break
          //   case '分':
          //     value = val * 0.01
          //     break
          // }
          // 处理传值的回显
          console.log(value, field, 'field0009')
          const setting = field.setting
            ? !isEmpty(JSON.parse(field.setting))
              ? JSON.parse(field.setting)
              : { web: {} }
            : { web: {} }
          // 千分位
          if (setting.web.millage) {
            value = Number(String(value).replace(/,/g, ''))
          }
          return value || ''
        }
      }
    }
  })
  // 座机号
  ;[fieldTypeConfig.landline].forEach(key => {
    formObj[key] = (field: Recordable) => {
      return {
        compName: customCompNameEnums.landline,
        placeholder: field.prompt || '请输入'
      }
    }
  })
  // 下拉单选 转介绍人
  ;[fieldTypeConfig.referralPerson].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.referralPerson,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 下拉单选 转介绍人来源
  ;[fieldTypeConfig.referralPersonSource].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.referralPersonSource,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 下拉单选 担保方
  ;[fieldTypeConfig.guarantee].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.guarantee,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  // 下拉单选 产品方
  ;[fieldTypeConfig.erpProduct].forEach(key => {
    formObj[key] = (field: Recordable) => ({
      compName: customCompNameEnums.erpProduct,
      placeholder: field.prompt || '请选择',
      dataList: field.columnDataList || []
    })
  })
  return formObj
}

export const dealFormConfig = createFormStrategy(formObj)

const formValObj = {}
// 处理表单回显值和设置值
export function createFormValueStrategy(formValObj: Recordable) {
  ;[
    fieldTypeConfig.select // 下拉单选
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = !isNullOrUndefOrEmpty(form[fieldCode]) ? form[fieldCode] : ''
        if (['sociaScop', 'car', 'house', 'publicReserveScop'].includes(fieldCode)) {
          return value !== '' ? (String(value) === '0' ? '0' : '30') : ''
        }
        return value !== '' ? String(value) : '' // 统一处理成字符类型
      },
      setValue: (value: any, field: Recordable, form: Recordable) => {
        console.log(value, 'value555')
        const { fieldCode } = field
        form[fieldCode] = value
      },
      getLabel: (field: Recordable, _form: Recordable) => {
        field.renderConfig.dataList
      }
    }
  })
  ;[
    fieldTypeConfig.checkbox, // 复选框
    fieldTypeConfig.multipleChoice, // 下拉多选
    fieldTypeConfig.tags, // 标签
    fieldTypeConfig.date2 // 日期区间
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = !isNullOrUndefOrEmpty(form[fieldCode]) ? form[fieldCode] : []
        console.log(value, 'valuepoppo', field)

        if (isArray(value) && !isEmpty(value)) {
          return value
        } else if (isString(value)) {
          return value?.split?.(',')
        } else if (isNumber(value)) {
          return [String(value)]
        } else {
          return []
        }
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        // form[fieldCode] = value ? value.join(',') : []
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.cascader // 级联
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || ''
        // 返回数组
        return value ? (isString(value) ? value?.split?.(',') : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        // form[fieldCode] = value ? value.join(',') : []
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.picture // 图片
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || []
        // 返回数组
        return value ? (isString(value) ? JSON.parse(value) : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
        console.log('图片', form[fieldCode])
      }
    }
  })
  ;[
    fieldTypeConfig.enclosure // 上传附件
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || []
        console.log(value, 'value333')
        // 返回数组
        return value ? (isString(value) ? JSON.parse(value) : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        console.log(value, 'value444')
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.money, // 金额
    fieldTypeConfig.number // 数字
  ].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = !isNullOrUndefOrEmpty(form[fieldCode]) ? form[fieldCode] : ''
        return value !== '' ? value : ''
      },
      setValue: (value: any, field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })
  // 引用，映射字段
  ;[fieldTypeConfig.quote, fieldTypeConfig.mapping].forEach(key => {
    formValObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        // 都是字符串
        return form[fieldCode] || ''
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })

  return formValObj
}

export const dealFormValConfig = createFormValueStrategy(formValObj)

const formValFilterObj = {}
// 处理快捷筛选和高级筛选回显值和设置值
function handleDate4SetValue(value: Recordable) {
  if (isString(value)) {
    if (isJSON(value)) {
      return JSON.parse(value)
    } else {
      const arrVal = value?.split?.(',')
      if (arrVal?.length) {
        const [startDate, endDate, startTime, endTime] = arrVal
        return [
          [startDate || null, endDate || null],
          [startTime, endTime]
        ]
      }
    }
    return [
      [null, null],
      [null, null]
    ]
  } else {
    return value
  }
}
export function createFormValueFilterStrategy(formValFilterObj: Recordable) {
  ;[
    fieldTypeConfig.select, // 下拉单选
    fieldTypeConfig.checkbox, // 复选框
    fieldTypeConfig.multipleChoice, // 下拉多选
    fieldTypeConfig.tags, // 标签
    fieldTypeConfig.date2, // 日期区间
    fieldTypeConfig.date4 // 日期区间
  ].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = !isNullOrUndefOrEmpty(form[fieldCode]) ? form[fieldCode] : []
        console.log(value, 'valuepoppo', field)

        if (isArray(value) && !isEmpty(value)) {
          return value
        } else if (isString(value)) {
          return value?.split?.(',')
        } else if (isNumber(value)) {
          return [String(value)]
        } else {
          return []
        }
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        // form[fieldCode] = value ? value.join(',') : []
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.cascader // 级联
  ].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || ''
        // 返回数组
        return value ? (isString(value) ? value?.split?.(',') : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        // form[fieldCode] = value ? value.join(',') : []
        form[fieldCode] = value
      }
    }
  })
  ;[fieldTypeConfig.date1, fieldTypeConfig.date3].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || ''
        if (field?.condition === 'date_interval' || form?.code === 'date_interval') {
          // 处理时间段
          return handleDate4SetValue(value)
        } else if (field?.condition === 'interval' || form?.code === 'interval') {
          // 处理区间
          return value?.split?.(',')
        }
        return value
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.picture // 图片
  ].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || []
        // 返回数组
        return value ? (isString(value) ? value?.split?.(',') : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.enclosure // 上传附件
  ].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        const value = form[fieldCode] || []
        // 返回数组
        return value ? (isString(value) ? value?.split?.(',') : value) : []
      },
      setValue: (value: any[], field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })
  ;[
    fieldTypeConfig.money, // 金额
    fieldTypeConfig.number // 数字
  ].forEach(key => {
    formValFilterObj[key] = {
      getValue: (field: Recordable, form: Recordable) => {
        // console.log(field, 'field2221')
        const { fieldCode } = field
        const value = !isNullOrUndefOrEmpty(form[fieldCode]) ? form[fieldCode] : ''
        return value !== '' ? value : ''
      },
      setValue: (value: any, field: Recordable, form: Recordable) => {
        const { fieldCode } = field
        form[fieldCode] = value
      }
    }
  })

  return formValFilterObj
}

export const dealFormValConfigFilter = createFormValueFilterStrategy(formValFilterObj)

// 客户按钮权限
export const customerBtnCode = {
  // 详情
  DETAIL_EDIT: 'DETAIL_EDIT', // 编辑客户
  DETAIL_WRITE_FOLLOW_RECORD: 'DETAIL_WRITE_FOLLOW_RECORD', // 写跟进
  DETAIL_DELETE_FOLLOW_RECORD: 'DETAIL_DELETE_FOLLOW_RECORD', // 删除跟进记录
  DETAIL_COMMENTS: 'DETAIL_COMMENTS', // 评论
  DETAIL_DELETE_COMMENT: 'DETAIL_DELETE_COMMENT', // 删除评论
  DETAIL_SET_STAGE: 'DETAIL_SET_STAGE', // 设置阶段
  DETAIL_CALL: 'DETAIL_CALL', // 打电话
  DETAIL_SET_LEVEL: 'DETAIL_SET_LEVEL', // 设置等级
  DETAIL_EDIT_TAGS: 'DETAIL_EDIT_TAGS', // 编辑标签
  DETAIL_CONCERN: 'DETAIL_CONCERN', // 关注客户
  DETAIL_HANDOVER_OVER: 'DETAIL_HANDOVER_OVER', // 移交客户
  DETAIL_MOVE_INTO_OPEN_SEA: 'DETAIL_MOVE_INTO_OPEN_SEA', // 移入公海
  DETAIL_APPOINTMENT_VISIT: 'DETAIL_APPOINTMENT_VISIT', // 预约上门

  DETAIL_ADD_ASSISTANTS: 'DETAIL_ADD_ASSISTANTS', // 添加协助人
  DETAIL_REMOVE_ASSISTANTS: 'DETAIL_REMOVE_ASSISTANTS', // 移除协助人
  DETAIL_BASIC_INFORMATION: 'DETAIL_BASIC_INFORMATION', // 基本信息
  DETAIL_CONTACT: 'DETAIL_CONTACT', // 联系人
  DETAIL_ADD_CONTACT: 'DETAIL_ADD_CONTACT', // 添加联系人
  DETAIL_DELETE_CONTACT: 'DETAIL_DELETE_CONTACT', // 删除联系人
  DETAIL_CONNECT_CUSTOMERS: 'DETAIL_CONNECT_CUSTOMERS', // 关联客户
  DETAIL_ADD_CONNECT_CUSTOMERS: 'DETAIL_ADD_CONNECT_CUSTOMERS', // 添加关联客户
  DETAIL_REMOVE_CONNECT_CUSTOMERS: 'DETAIL_REMOVE_CONNECT_CUSTOMERS', // 移除关联客户

  DETAIL_CUSTOMER_ORDER_FEEDBACK: 'DETAIL_CUSTOMER_ORDER_FEEDBACK', // 客单反馈
  DETAIL_NUMBER_VERIFICATION: 'DETAIL_NUMBER_VERIFICATION', // 号码校验
  DETAIL_DELETE: 'DETAIL_DELETE', // 删除客户
  DETAIL_BUSINESS_DATA: 'DETAIL_BUSINESS_DATA', // 业务数据（做单）
  DETAIL_CPS_BUSINESS_DATA: 'DETAIL_CPS_BUSINESS_DATA', // 业务数据（CPS）

  TRANSFER_CUSTOMER: 'TRANSFER_CUSTOMER', // 详情转客户

  DETAIL_CONTACT_CONDITION: 'DETAIL_CONTACT_CONDITION', // 联系情况
  CREDIT_REPORT: 'CREDIT_REPORT', // 信用报告
  // 客户详情end
  // 客户列表start
  LIST_WRITE_FOLLOW_RECORD: 'LIST_WRITE_FOLLOW_RECORD', // 写跟进
  LIST_CALL: 'LIST_CALL', // 打电话
  LIST_SET_STAGE: 'LIST_SET_STAGE', // 设置阶段
  LIST_SET_LEVEL: 'LIST_SET_LEVEL', // 设置等级
  LIST_EDIT_TAGS: 'LIST_EDIT_TAGS', // 编辑标签
  LIST_CONTACT_CONDITION: 'LIST_CONTACT_CONDITION', // 联系情况
  // 客户列表end
  // 客户列表全局start
  CREATE: 'CREATE', // 创建客户
  SET_STAGE: 'SET_STAGE', // 设置阶段
  SET_LEVEL: 'SET_LEVEL', // 设置等级
  EDIT_TAGS: 'EDIT_TAGS', // 编辑标签
  CONCERN: 'CONCERN', // 关注客户
  CANCEL_CONCERN: 'CANCEL_CONCERN', // 取消关注客户
  IMPORT: 'IMPORT', // 导入客户
  EXPORT: 'EXPORT', // 导出客户
  HAND_OVER: 'HAND_OVER', // 移交客户
  MOVE_INTO_OPEN_SEA: 'MOVE_INTO_OPEN_SEA', // 移入公海
  BATCH_CUSTOMER_ORDER_FEEDBACK: 'BATCH_CUSTOMER_ORDER_FEEDBACK', // 客单反馈
  DELETE: 'DELETE', // 删除客户
  GLOBAL_TRANSFER_CUSTOMER: 'GLOBAL_TRANSFER_CUSTOMER', // 列表转客户
  COMMON_PHRASES: 'COMMON_PHRASES', // 常用语
  // 客户列表全局end
  // 列表批量
  BATCH_DELETE: 'BATCH_DELETE', // 批量删除
  STAGE_ROLL_BACK: 'STAGE_ROLL_BACK', // 阶段回退
  WEI_XIN_RECORD: 'WEI_XIN_RECORD' // 微信记录
}
// 公海按钮权限
export const seaBtnCode = {
  // 详情start
  DETAIL_RECEIVE: 'DETAIL_RECEIVE', // 领取客户
  DETAIL_ASSIGNMENT: 'DETAIL_ASSIGNMENT', // 分配客户
  DETAIL_BASIC_INFORMATION: 'DETAIL_BASIC_INFORMATION', // 基本信息
  DETAIL_CONTACT: 'DETAIL_CONTACT', // 联系人
  DETAIL_CONNECT_CUSTOMERS: 'DETAIL_CONNECT_CUSTOMERS', // 关联客户
  DETAIL_DELETE: 'DETAIL_DELETE', // 删除客户
  // 详情end
  // 列表全局start
  IMPORT: 'IMPORT', // 导入客户
  RECEIVE: 'RECEIVE', // 领取客户
  ASSIGNMENT: 'ASSIGNMENT', // 分配客户
  TRANSFER: 'TRANSFER', // 转移客户
  DELETE: 'DELETE', // 删除客户
  EXPORT: 'EXPORT', // 导出客户
  // 列表全局end
  // 列表批量start
  BATCH_DELETE: 'BATCH_DELETE' // 批量删除
}
// 自定义应用按钮权限
export const customerPageBtnCode = {
  CREATE: 'CREATE', // 新建客户
  SAVE: 'SAVE', // 保存
  CANCEL: 'CANCEL', // 取消
  RECEIVE: 'RECEIVE', // 领取
  ASSIGNMENT: 'ASSIGNMENT', // 分配
  DELETE: 'DELETE', // 删除
  APPROVAL: 'APPROVAL', // 审批
  HEADER_CONFIG: 'HEADER_CONFIG', // 表头配置
  EXPORT: 'EXPORT', // 导出
  BATCH_INITIATE_INTERVIEW: 'BATCH_INITIATE_INTERVIEW', // 批量发起签约
  INITIATE_INTERVIEW: 'INITIATE_INTERVIEW' // 发起签约
}
// 员工自动分配
export const staffAutoAssignConfigBtnCode = {
  UPDATE: 'UPDATE', // 更新规则
  BATCH_NOTICE_SWITCH: 'BATCH_NOTICE_SWITCH', // 批量开启关闭通知
  ADD: 'ADD', // 新增
  SET_PRIORITY: 'SET_PRIORITY', // 设置优先级
  ENABLE_OR_DISABLE: 'ENABLE_OR_DISABLE', // 批量启用禁用
  DELETE: 'DELETE' // 删除
}

// 公海自动分配
export const HighSeaAutoAssignConfigBtnCode = {
  SET_PRIORITY: 'SET_PRIORITY', // 设置优先级
  UPDATE: 'UPDATE', // 更新
  DELETE: 'DELETE', // 删除
  ADD: 'ADD', // 新增
  BATCH_SWITCH: 'BATCH_SWITCH' // 批量启用禁用
}

// 自动回收规则
export const recyclingRulesConfigBtnCode = {
  UPDATE: 'UPDATE', // 更新规则
  SET: 'SET', // 设置
  ADD: 'ADD', // 新增
  ENABLE_OR_DISABLE: 'ENABLE_OR_DISABLE', // 启用禁用
  DELETE: 'DELETE', // 删除
  COPY: 'COPY', // 复制
  HOLIDAY_SET: 'HOLIDAY_SET' // 放假设置
}

// 标签配置
export const customerTagsConfigtnCode = {
  MOVE: 'MOVE', // 移动标签组
  ADD: 'ADD', // 新增
  ENABLE_OR_DISABLE: 'ENABLE_OR_DISABLE', // 启用禁用
  DELETE: 'DELETE', // 删除
  UPDATE: 'UPDATE' // 更新
}
// 客户阶段配置
export const customerStageConfigtnCode = {
  DELETE_ORDER: 'DELETE_ORDER', // 删除有客单
  MOVE: 'MOVE', // 移动标签组
  ADD: 'ADD', // 新增
  ENABLE_OR_DISABLE: 'ENABLE_OR_DISABLE', // 启用禁用
  DELETE: 'DELETE', // 删除
  UPDATE: 'UPDATE' // 更新
}
// 结算单
export const sattlementCode = {
  SETTLEMENT_DETAIL_VIEW: 'VIEW', // 查看
  SETTLEMENT_DETAIL_ACK: 'VERIFY' // 确认签收
}
// BPM 做单中心 签单管理
export const signManageCode = {
  ADD: 'ADD', // 新增签单
  UPDATE: 'UPDATE', // 编辑
  DELETE: 'DELETE', // 删除
  SIGN_INVALID: 'SIGN_INVALID', // 签单作废
  BATCH_DELETE: 'BATCH_DELETE', // 批量删除
  EXPORT: 'EXPORT', // 导出
  VIEW: 'VIEW', // 查看详情
  PHASE_CONFIG: 'PHASE_CONFIG', // 阶段配置
  BATCH_SEND_SIGN: 'BATCH_INITIATE_INTERVIEW', // 批量发起签约
  SEND_SIGN: 'INITIATE_INTERVIEW' // 批量发起签约
}
// BPM 做单中心 上门预约
export const appiontVisitCode = {
  // 列表的
  LIST_ASSIGN_NEGOTIATOR: 'LIST_ASSIGN_NEGOTIATOR', // 分配谈单人
  LIST_CREATE_ORDER: 'LIST_CREATE_ORDER', // 创建订单
  LIST_SEND_INVITATION_CODE: 'LIST_SEND_INVITATION_CODE', // 发送邀约码
  LIST_MARK_DOOR: 'LIST_MARK_DOOR', // 标记上门
  LIST_COPY_INVITATION_CODE: 'LIST_COPY_INVITATION_CODE', // 复制邀约码
  ADD: 'ADD', // 新增预约
  GENERATE_QR_CODE: 'GENERATE_QR_CODE', // 生成二维码
  ASSIGN_NEGOTIATOR: 'ASSIGN_NEGOTIATOR', // 分配谈单人
  CREATE_ORDER: 'CREATE_ORDER', // 创建订单
  MARK_DOOR: 'MARK_DOOR', // 标记上门
  UNMARK_DOOR: 'UNMARK_DOOR', // 标记未上门
  UPDATE: 'UPDATE', // 编辑
  EXPORT: 'EXPORT', // 导出
  DELETE: 'DELETE', // 删除
  HAND_OVER: 'HAND_OVER',
  BATCH_DELETE: 'BATCH_DELETE' // 批量删除
}
// BPM 做单中心 询单
export const inquiryManageCode = {
  DELETE: 'DELETE',
  // 列表的
  LIST_SHARE: 'LIST_SHARE',
  LIST_VIEW: 'LIST_VIEW', // 查看详情
  LIST_HANDLE_ORDER: 'LIST_HANDLE_ORDER', // 列表处理订单
  LIST_CREATE_ORDER: 'LIST_CREATE_ORDER', // 创建订单
  ADD: 'ADD', // 新增预约
  DETAIL_UPDATE: 'DETAIL_EDIT',
  DETAIL_SHARE: 'DETAIL_SHARE', // 详情分享
  DETAIL_HANDLE_ORDER: 'DETAIL_HANDLE_ORDER', // 处理订单
  DETAIL_CREATE_ORDER: 'DETAIL_CREATE_ORDER' // 创建订单
}

// 办抵工单
export enum HandleOrderBtnAuthEnum {
  EXPORT = 'EXPORT', // 导出
  VIEW = 'VIEW', // 查看
  TRANSACT = 'TRANSACT', // 办理
  DETAIL_TRANSACT = 'DETAIL_TRANSACT' // 详情办理
}

// erp应收款管理
export const receivablesCode = {
  // 列表的
  EXPORT: 'EXPORT', // 导出
  BATCH_ONLINE_DEDUCTION: 'BATCH_ONLINE_DEDUCTION', // 批量线上代扣
  BATCH_OFFLINE_REPAYMENT: 'BATCH_OFFLINE_REPAYMENT', // 批量线下还款
  DETAIL: 'DETAIL', // 详情
  MESSAGE_NOTIFICATION: 'MESSAGE_NOTIFICATION', // 短信通知
  OFFLINE_REPAYMENT: 'OFFLINE_REPAYMENT', // 线下还款
  ONLINE_DEDUCTION: 'ONLINE_DEDUCTION', // 线上扣款
  EDIT: 'EDIT', // 编辑
  GUARANTEE_PAY: 'GUARANTEE_PAY', // 发起代偿
  TRANSFER_PAYMENT: 'TRANSFER_PAYMENT', // 转账还款
  BATCH_TRANSFER_PAYMENT: 'BATCH_TRANSFER_PAYMENT', // 转账还款批量
  // 详情
  DETAIL_GUARANTEE_PAY: 'DETAIL_GUARANTEE_PAY', // 发起代偿
  INFO_EDIT: 'INFO_EDIT', // 编辑
  INFO_ONLINE_DEDUCTION: 'INFO_ONLINE_DEDUCTION', // 线上扣款
  INFO_OFFLINE_REPAYMENT: 'INFO_OFFLINE_REPAYMENT', // 线下还款
  INFO_MESSAGE_NOTIFICATION: 'INFO_MESSAGE_NOTIFICATION', // 短信通知
  INFO_TRANSFER_PAYMENT: 'INFO_TRANSFER_PAYMENT' // 转账还款详情
}

// erp账单管理
export const billCode = {
  DETAIL: 'DETAIL', // 详情
  EXPORT: 'EXPORT', // 导出
  CREDIT_ASSIGNMENT: 'CREDIT_ASSIGNMENT', // 债权转让
  ADDED_REPAYMENT_DATA: 'ADDED_REPAYMENT_DATA', // 新增应还款数据
  EDIT: 'EDIT', // 编辑
  ONLINE_DEDUCTION: 'ONLINE_DEDUCTION', // 线上扣款
  OFFLINE_REPAYMENT: 'OFFLINE_REPAYMENT', // 线下还款
  MESSAGE_NOTIFICATION: 'MESSAGE_NOTIFICATION', // 短信通知
  PREPAYMENT: 'PREPAYMENT', // 提前还款
  CLEARANCECERTIFICATE: 'CLEARANCECERTIFICATE', // 结清证明
  CONFIRMEDLOAN: 'CONFIRMEDLOAN', // 确认放款
  FIVELEVEL: 'FIVELEVEL' // 五级分类
}
type Rule = {
  // 根据实际需求定义 _rule 的类型
  [key: string]: any
}

type ValidateCallback = (arg0?: Error | undefined) => void
const createRuleStrategy = (strategys: any) => {
  // 数字,金额, 百分数
  ;[fieldTypeConfig.number, fieldTypeConfig.money, fieldTypeConfig.percentage].forEach(key => {
    strategys[key] = (data: any, onlyErrorMsg: any) => {
      // /^(\d+|\d+\.\d{1,2})$/, '请输入正确的数字，且最多输入两位小数' , /^(\d)*$/, '请输入正确的数字'
      const precisions = data.precisions || 0
      const str = `^(\\d+|\\d+\\.\\d{0,${precisions}})$`
      const reg = precisions > 0 ? new RegExp(str) : /^(\d)*$/
      const minValue = isNullOrUndefOrEmpty(data.minValue) ? '' : Number(data.minValue)
      const maxValue = isNullOrUndefOrEmpty(data.maxValue) ? '' : Number(data.maxValue)

      const validateFn = (_rule: Rule, value: string | number, callback: ValidateCallback) => {
        console.log(value, 'value2222', data)
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (precisions && !reg.test(String(value).replace(/,/g, ''))) {
          // && value.includes('.')
          callback(new Error(`小数点不能超过${precisions}位`))
        } else if (
          !isNullOrUndefOrEmpty(value) &&
          !isNullOrUndefOrEmpty(minValue) &&
          value < minValue
        ) {
          console.log('执行1233', minValue, 'minValue')
          callback(new Error(`不能低于最小${minValue}`))
        } else if (
          !isNullOrUndefOrEmpty(value) &&
          !isNullOrUndefOrEmpty(maxValue) &&
          value > maxValue
        ) {
          callback(new Error(`不能超过最大值${maxValue}`))
        } else if (
          [fieldTypeConfig.money, fieldTypeConfig.percentage].includes(key as any) &&
          !/^(?!0\d)\d+(\.\d+)?$/.test(String(value).replace(/,/g, ''))
        ) {
          callback(new Error('格式不正确'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? {
            reg,
            errMsg: `小数点不能超过${precisions}位`,
            validateFn: (value: string | number) => {
              let result = ''
              if (isNullOrUndefOrEmpty(value)) {
                // 必填选项在外面判断
                result = ''
              } else if (!reg.test(String(value).replace(/,/g, ''))) {
                result = `小数点不能超过${precisions}位`
              } else if (
                !isNullOrUndefOrEmpty(value) &&
                !isNullOrUndefOrEmpty(minValue) &&
                value < minValue
              ) {
                result = `不能低于最小值${minValue}`
              } else if (
                !isNullOrUndefOrEmpty(value) &&
                !isNullOrUndefOrEmpty(maxValue) &&
                value > maxValue
              ) {
                result = `不能超过最大值${maxValue}`
              } else {
                result = ''
              }
              return result
            }
          }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 身份证
  ;[fieldTypeConfig.idCard].forEach(key => {
    strategys[key] = (_data: any, onlyErrorMsg: any) => {
      const reg = idCardReg
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的身份证号'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? { reg: reg, errMsg: '请输入正确的身份证号' }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 手机
  ;[fieldTypeConfig.phone].forEach(key => {
    strategys[key] = (_data: any, onlyErrorMsg: any) => {
      const reg = /^1[3-9]\d{9}$/
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (!phoneIsDesensitization(value) && !reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? { reg, errMsg: '请输入正确的手机号' }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 邮箱
  ;[fieldTypeConfig.email].forEach(key => {
    strategys[key] = (_data: any, onlyErrorMsg: any) => {
      const reg = emailReg
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? { reg, errMsg: '请输入正确的邮箱' }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 座机号
  ;[fieldTypeConfig.landline].forEach(key => {
    strategys[key] = (data: any, onlyErrorMsg: any) => {
      const reg = /^(0\d{2,3}-)?([2-9]\d{6,7})+(-\d{1,6})?$/
      // 必填
      const current = data.columnOperateList.find((operate: Recordable) => {
        return operate.value && operate.code === operateListEnum.MUST
      })
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (current && !reg.test(value)) {
          callback(new Error('请输入正确的座机号'))
        } else if (value && value !== '-' && !reg.test(value)) {
          callback(new Error('请输入正确的座机号'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? { reg, errMsg: '请输入正确的座机号' }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 社会信用代码
  ;[fieldTypeConfig.creditCode].forEach(key => {
    strategys[key] = (_data: any, onlyErrorMsg: any) => {
      const reg = /^[0-9A-Z]+$/
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        console.log(reg.test(value), '统一社会信用代码长度为18位')
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (value.length < 18) {
          callback(new Error('统一社会信用代码长度为18位'))
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的统一社会信用代码'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? { reg, errMsg: '请输入正确的统一社会信用代码' }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  // 地址
  ;[fieldTypeConfig.address].forEach(key => {
    strategys[key] = (
      data: { columnOperateList: any[]; precisions: number },
      onlyErrorMsg: any
    ) => {
      // 根据精度确认必填的地址
      // 必填
      const current = data.columnOperateList.find((operate: Recordable) => {
        return operate.value && operate.code === operateListEnum.MUST
      })
      const checkAddress = (value: string) => {
        const valueObj = JSON.parse(value)
        console.log('%c 地址value', 'font-size:20px;color:red', valueObj)

        if (data.precisions === 1) {
          return valueObj.province && valueObj.city && valueObj.area && valueObj.detail
        } else if (data.precisions === 2) {
          return valueObj.province && valueObj.city && valueObj.area
        } else if (data.precisions === 3) {
          return valueObj.province && valueObj.city
        } else if (data.precisions === 4) {
          return valueObj.province
        }
      }
      const validateFn = (_rule: Rule, value: string, callback: ValidateCallback) => {
        if (isNullOrUndefOrEmpty(value)) {
          // 必填选项在外面判断
          callback()
        } else if (current && !checkAddress(value)) {
          callback(new Error('请输入完整的地址'))
        } else {
          callback()
        }
      }
      return onlyErrorMsg
        ? {
            validateFn: (value: string) => {
              let result = ''
              if (!checkAddress(value)) {
                result = '地址不完整'
              }
              return result
            },
            errMsg: '请输入完整的地址'
          }
        : { validator: validateFn, trigger: 'blur' }
    }
  })
  return strategys
}
export const ruleStrategy = createRuleStrategy({})

// 引用字段
export const isQuote = (fieldType: fieldTypeEnum) =>
  fieldType === fieldTypeEnum.SYS_QUOTE ||
  fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
  fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
  fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE
// 映射字段
export const isMapping = (fieldType: fieldTypeEnum) =>
  fieldType === fieldTypeEnum.SYS_MAPPING ||
  fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
  fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
  fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING

// 是否是关联查询字段
export const isAssociatedQuery = (fieldType: fieldTypeEnum) =>
  isQuote(fieldType) || isMapping(fieldType)

// 呼叫中心权限
export const callCenterBtnCode = {
  // 通话记录
  PLAY_RECORDING: 'PLAY_RECORDING', // 播放录音
  DOWNLOAD_RECORDING: 'DOWNLOAD_RECORDING', // 下载录音
  // 轮呼
  TURN_CALL_DELETE: 'DELETE', // 轮呼删除
  TURN_CALL_UPDATE: 'UPDATE', // 轮呼编辑
  TURN_CALL_CREATE_PERSONAL_TASK: 'CREATE_PERSONAL_TASK', // 轮呼创建个人任务
  TURN_CALL_ASSIGN_TASK: 'ASSIGN_TASK', // 轮呼指派任务
  ADD_ROUND_CALL: 'ADD_ROUND_CALL', // 添加到轮呼
  // 群呼
  GROUP_CALL_CREATE: 'CREATE', // 群呼新建
  GROUP_CALL_DELETE: 'DELETE', // 群呼删除
  GROUP_CALL_RUN_PAUSE_TASK: 'RUN_PAUSE_TASK', // 群呼运行/暂停
  GROUP_CALL_UPDATE: 'UPDATE', // 群呼编辑
  GROUP_CALL_DETAILS: 'DETAILS' // 群呼详情
}
// 企业后台-呼叫中心配置权限
export const callCenterConfigBtnCode = {
  // 坐席管理
  SEAT_BIND: 'BIND', // 坐席-绑定
  SEAT_UNTIE: 'UNTIE', // 坐席-解绑
  SEAT_BATCH_BIND: 'BATCH_BIND', // 坐席-批量绑定
  SEAT_BATCH_UNTIE: 'BATCH_UNTIE', // 坐席-批量解绑
  SEAT_LINE_MANAGEMENT: 'LINE_MANAGEMENT', // 坐席-线路管理
  SEAT_BATCH_ROUT: 'BATCH_ROUT', // 坐席-批量配置线路
  SEAT_EDIT_GROUP: 'EDIT_GROUP', // 坐席-编辑分组
  SEAT_DELETE_GROUP: 'DELETE_GROUP', // 坐席-删除分组
  SEAT_CREATE_GROUP: 'CREATE_GROUP' // 坐席-创建分组
}

// 展业管理-相关按钮配置权限
export const displayBusinessBtnCode = {
  // 产品管理
  BROKERAGE_CONFIG: 'brokerage_config', // 佣金配置
  SHARE_PRODUCT: 'share_product', // 分享产品
  PROMPTLY_INTO: 'promptly_into', // 立即进件
  H5_PRODUCT_CONFIG: 'h5_product_config', // H5产品配置
  VIEW_PRODUCT: 'view_product', // 详情
  ENABLE_DISABLE_PRODUCT: 'enable_disable_product', // 上架/下架
  DEL_PRODUCT: 'del_product', // 删除
  EDIT_PRODUCT: 'edit_product', // 编辑
  ADD_PRODUCT: 'add_product', // 新建产品
  REQ_FIELD_CONFIG: 'request_field_config', // 配置请求字段
  EXAMINE_APPROVE: 'examine_approve', //审批
  // 渠道管理
  ADD_CHANNEL: 'add_channel', // 添加
  INFO_CHANNEL: 'info_channel', // 详情
  EDIT_CHANNEL: 'edit_channel', // 编辑
  ENABLE_DISENABLE_CHANNEL: 'enable_disable_channel', // 启用/禁用
  ACTIVE_CHANNEL: 'active_channel', // 激活
  ADD_ADJUST_COMMISSION_PRODUCT: 'add_adjust_commission_product', // 新建调佣产品

  // 进件订单管理
  INSERT_ORDER: 'dis_insert_order', // 新增进件
  EDIT_INTO: 'edit_into', // 编辑
  INTO_DETAIL: 'into_detail', // 详情
  DELETE_INTO: 'dis_delete_order', // 删除
  INTO_OPERATE_LOG: 'into_operate_log', // 操作日志

  // 资金方管理
  VIEW_UPSTREAM_ORGAN: 'view_upstream_organ', // 详情
  STOP_UPSTREAM_ORGAN: 'stop_upstream_organ', // 停止合作/重新合作
  DEL_UPSTREAM_ORGAN: 'del_upstream_organ', // 删除
  EDIT_UPSTREAM_ORGAN: 'edit_upstream_organ', // 编辑
  EXPORT_UPSTREAM_ORGAN: 'export_upstream_organ', // 导出
  ADD_UPSTREAM_ORGAN: 'add_upstream_organ', // 添加

  // 账单管理
  RECOVER: 'RECOVER', // 恢复待审批状态
  DETAIL_EXAMINE: 'DEATIL_EXAMINE', // 审核
  EXPORT: 'EXPORT', // 导出
  BATCH_EXAMINE: 'BATCH_EXAMINE', // 批量审核
  EXAMINE: 'EXAMINE', // 业务审核
  DETAIL: 'DETAIL', // 查看详情
  CREATE_BILL: 'CREATE_BILL', // 新建账单

  FINANCE_DETAIL: 'FINANCE_DETAIL', // 查看详情
  DEATIL_FINANCE_EXAMINE: 'DEATIL_FINANCE_EXAMINE', // 审核
  FINANCE_EXAMINE: 'FINANCE_EXAMINE', // 财务审核

  // 提现管理
  CASHOUT_DETAIL_EXAMINE: 'DEATIL_EXAMINE', // 审核
  CASHOUT_EXPORT: 'EXPORT', // 导出
  CASHOUT_EXAMINE: 'EXAMINE', // 审核
  CASHOUT_DETAIL: 'DETAIL' // 查看详情
}

// 以下字段在关联已有数据时只关联单条，且用自己本身的组件

export const associatedDataExclude = [
  fieldTypeConfig.date1,
  fieldTypeConfig.date2,
  fieldTypeConfig.date3,
  fieldTypeConfig.address,
  fieldTypeConfig.landline
]

// 按钮关联动作
export const btnActives = [
  {
    value: 'CREATOR_TABLE',
    label: '新增表单'
  },
  {
    value: 'UPDATE_NOW_TABLE_DATA',
    label: '更新当前表单数据'
  },
  {
    value: 'OPEN_URL',
    label: '打开新链接'
  }
  // {
  //   value: 'UPDATE_LINK_TABLE_DATA',
  //   label: '更新他表数据'
  // }
]

// 打开方式
export const openStyles = [
  {
    label: '打开弹窗',
    value: 'ALERT'
  },
  {
    label: '打开新标签页',
    value: 'NEW_TAB'
  }
]

// 获取当前表单中的所有字段
export function getPositionsAllField(list: Recordable[]) {
  const arr: Recordable[] = []
  list.forEach(item => {
    if (item?.code === 'TABLE') {
      item?.children?.forEach((item: { modules: any[] }) => {
        if (item.modules) {
          item.modules.forEach(item => {
            if (
              (item.moduleType === moduleType.subField || item.moduleType === moduleType.subList) &&
              item.componentList
            ) {
              item.componentList.forEach(
                (item: { fieldBaseData: { columnInfo: Recordable<any> } }) => {
                  arr.push({ ...item.fieldBaseData.columnInfo, isTable: true })
                }
              )
            }
          })
        }
      })
    } else {
      item?.modules?.forEach((item: { moduleType: moduleType; componentList: any[] }) => {
        // 只取分栏和子表
        if (
          (item.moduleType === moduleType.subField || item.moduleType === moduleType.subList) &&
          item.componentList
        ) {
          item.componentList.forEach(item => {
            arr.push({ ...item.fieldBaseData.columnInfo, isTable: false })
          })
        }
      })
    }
  })
  return arr
}

// 是子表字段
export const isSubList = (fieldType: number) =>
  fieldType === fieldTypeEnum.SON_ORIGINAL_FIELD ||
  fieldType === fieldTypeEnum.SON_CUSTOM_FIELD ||
  fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
  fieldType === fieldTypeEnum.SON_CUSTOM_QUOTE ||
  fieldType === fieldTypeEnum.SON_SYS_MAPPING ||
  fieldType === fieldTypeEnum.SON_CUSTOM_MAPPING

// 是主表字段
export const isField = (fieldType: number) =>
  fieldType === fieldTypeEnum.ORIGINAL ||
  fieldType === fieldTypeEnum.SYS_QUOTE ||
  fieldType === fieldTypeEnum.CUSTOM_QUOTE ||
  fieldType === fieldTypeEnum.SYS_MAPPING ||
  fieldType === fieldTypeEnum.CUSTOM_MAPPING ||
  fieldType === fieldTypeEnum.CUSTOM_EXTEND
// 工作台权限
export const workbenchBtnCode = {
  MISSION_CENTER: 'MISSION_CENTER', // 任务中心
  DATA_OVERVIEW: 'DATA_OVERVIEW', // 数据概览
  OFFLINE_CLIENTELE: 'OFFLINE_CLIENTELE' // 线下拓客
}

// 获取当前表单中处理结构之前的所有字段
export function getPositionsAllFieldForApi(list: Recordable[]) {
  const arr: Recordable[] = []
  list.forEach(item => {
    if (item.code === 'TABLE') {
      item.children.forEach((item: { modules: any[] }) => {
        if (item.modules) {
          item.modules.forEach(item => {
            if (
              (item.moduleType === moduleType.subField || item.moduleType === moduleType.subList) &&
              item.componentList
            ) {
              item.componentList.forEach((item: { columnInfo: Recordable<any> }) => {
                arr.push({ ...item.columnInfo })
              })
            }
          })
        }
      })
    } else {
      item.modules.forEach((item: { moduleType: moduleType; componentList: any[] }) => {
        // 只取分栏和子表
        if (
          (item.moduleType === moduleType.subField || item.moduleType === moduleType.subList) &&
          item.componentList
        ) {
          item.componentList.forEach(item => {
            arr.push({ ...item.columnInfo })
          })
        }
      })
    }
  })
  return arr
}

// 是预定字段
export const isPreField = (fieldType: fieldTypeEnum) =>
  fieldType === fieldTypeEnum.ORIGINAL ||
  fieldType === fieldTypeEnum.SYS_QUOTE ||
  fieldType === fieldTypeEnum.SYS_MAPPING ||
  fieldType === fieldTypeEnum.SON_ORIGINAL_FIELD ||
  fieldType === fieldTypeEnum.SON_SYS_QUOTE ||
  fieldType === fieldTypeEnum.SON_SYS_MAPPING

// 根据传入的serial去找到对应的字段，该字段必须是普通字段
export function findField(positions: Recordable[], columnSerial: string): Recordable {
  let obj: Recordable = {}
  positions.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (field.fieldSerial === columnSerial) {
            obj = field
            return
          }
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach((child: { modules: any[] }) => {
        child.modules.forEach(module => {
          module.componentList.forEach((field: Recordable) => {
            if (field.fieldSerial === columnSerial) {
              obj = field
              return
            }
          })
        })
      })
    }
  })
  return obj
}

// 根据原表source，找到对应字段
export function findFieldBySource(positions: Recordable[], columnSerial: string): Recordable {
  let obj: Recordable = {}
  positions.forEach(container => {
    if (container.code === 'BLANK') {
      container.modules.forEach((module: Recordable) => {
        module.componentList.forEach((field: Recordable) => {
          if (field?.columnQuoteInfo?.sourceColumnSerial === columnSerial) {
            obj = field
            return
          }
        })
      })
    }
    if (container.code === 'TABLE') {
      container.children.forEach((child: { modules: any[] }) => {
        child.modules.forEach(module => {
          module.componentList.forEach((field: Recordable) => {
            if (field?.columnQuoteInfo?.sourceColumnSerial === columnSerial) {
              obj = field
              return
            }
          })
        })
      })
    }
  })
  return obj
}

// 获取当前表单中的所有分栏字段
export function getPositionsSubField(list: Recordable[]) {
  const arr: Recordable[] = []
  list.forEach(item => {
    if (item.code === 'TABLE') {
      item.children.forEach((item: { modules: any[] }) => {
        if (item.modules) {
          item.modules.forEach(item => {
            if (item.moduleType === moduleType.subField && item.componentList) {
              item.componentList.forEach(
                (item: { fieldBaseData: { columnInfo: Recordable<any> } }) => {
                  arr.push({ ...item.fieldBaseData.columnInfo })
                }
              )
            }
          })
        }
      })
    } else {
      item.modules.forEach((item: { moduleType: moduleType; componentList: any[] }) => {
        // 只取分栏和子表
        if (item.moduleType === moduleType.subField && item.componentList) {
          item.componentList.forEach(item => {
            arr.push({ ...item.fieldBaseData.columnInfo })
          })
        }
      })
    }
  })
  return arr
}

// 公式计算中的值转换
/**
 * @author Mr.zhang
 * @params value(计算值)，unit1(值的单位)，unit2(换算值的单位)
 * 单位：分，角，元，万，千万
 * @return 转换之后的值
 * */
export function equationTransferValue(value: any, unit1: string, unit2: string) {
  if (!isNullOrUndefOrEmpty(value)) {
    // unit1和unit2是什么关系
    return unitTransferFn(unit1 || '元', unit2 || '元') * value
  }
}
export function unitTransferFn(unit1: string, unit2: string) {
  let multiple = 1
  // const arr = ['分', '角', '元', '万', '千万']
  const obj: Recordable<number> = {
    // 以元作为基准单位
    分: 0.01,
    角: 0.1,
    元: 1,
    万: 10000,
    千万: 10000000
  }
  multiple = obj[unit1] / obj[unit2]
  return multiple
}

// 判断当前分栏是否在布局当中
export function findSubField(moduleSerial: string, list: Recordable[]) {
  let flag = false
  list.forEach(item => {
    if (item.code === 'TABLE') {
      item.children.forEach((item: { modules: any[] }) => {
        if (item.modules) {
          const cur = item.modules.find(module => module.moduleSerial === moduleSerial)
          if (cur) {
            flag = true
          }
        }
      })
    } else {
      const cur = item.modules.find(
        (module: { moduleSerial: string }) => module.moduleSerial === moduleSerial
      )
      if (cur) {
        flag = true
      }
    }
  })
  return flag
}
